const isVideoDef = (value: any): value is VideoDef =>
  value && (value as VideoDef).format !== undefined;

export default isVideoDef;
